<template>
	<div>
		<h1 class="page-header mb-0"><i class="fas fa-user"></i> Profilom</h1>
		<div class="row">
			<div class="alert alert-danger mt-2" v-if="!user.email_verified_at"><h4><i class="fa fa-exclamation-triangle"></i> A rendszer használatához meg kell változtatnia az alapértelmezett jelszavát!</h4></div>
			<div class="col-12 col-md-6">
				<panel title="Alapadatok">
					<form @submit.prevent="updateUser">
						<div class="form-group">
							<label class="form-label">Név:</label>
							<input type="text" class="form-control" v-model="form_user.name">
							<div class="invalid-feedback d-block" v-if="errors.name">
									{{ errors.name[0] }}
							</div>
						</div>
						<div class="form-group mt-2">
							<label class="form-label">Email:</label>
							<input type="email" class="form-control" v-model="form_user.email">
							<div class="invalid-feedback d-block" v-if="errors.email">
									{{ errors.email[0] }}
							</div>
						</div>
						<button class="btn btn-success mt-2 float-end"><i class="fa fa-save"></i> Mentés</button>
					</form>
				</panel>
			</div>
			<div class="col-12 col-md-6">
				<panel title="Jelszó változtatás">
					<form @submit.prevent="updatePassword">
						<div class="form-group">
							<label class="form-label">Új Jelszó:</label>
							<input type="password" autocomplete="off" class="form-control" v-model="password1" required>
							<div class="invalid-feedback d-block" v-if="errors.password">
									{{ errors.password[0] }}
							</div>
						</div>
						<div class="form-group mt-2">
							<label class="form-label">Új Jelszó mégegyszer:</label>
							<input type="password" autocomplete="off" class="form-control" v-model="password2" required>
							<div class="invalid-feedback d-block" v-if="errors.password">
									{{ errors.password[0] }}
							</div>
						</div>
						<button class="btn btn-success mt-2 float-end"><i class="fa fa-save"></i> Jelszó megváltoztatása</button>
					</form>
				</panel>
			</div>

			<div class="col-12 col-md-6">
				<panel title="PIN változtatás">
					<form @submit.prevent="updatePin">
						<div class="form-group">
							<label class="form-label">Új PIN:</label>
							<input type="password" autocomplete="off" class="form-control" v-model="pin1" maxlength="6" inputmode="numeric" required>
							<div class="invalid-feedback d-block" v-if="errors.pin">
									{{ errors.pin[0] }}
							</div>
						</div>
						<div class="form-group">
							<label class="form-label">Új PIN mégegyszer:</label>
							<input type="password" autocomplete="off" class="form-control" v-model="pin2" maxlength="6" inputmode="numeric" required>
							<div class="invalid-feedback d-block" v-if="errors.pin">
									{{ errors.pin[0] }}
							</div>
						</div>
						<button class="btn btn-success mt-2 float-end"><i class="fa fa-save"></i> PIN megváltoztatása</button>
					</form>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
	import User from "../../apis/User";
	import Confirmation from "../../apis/Confirmation";
	export default {
		data() {
			return {
				password1: null,
				password2: null,
				pin1: null,
				pin2: null,
				form_user: {},
				errors:[],
			}
		},
		computed:{
			user(){
				return this.$store.state.user;
			},
		},
		watch:{
			user:function(){
				this.form_user = JSON.parse(JSON.stringify(this.user));
			}
		},
		mounted(){
			this.form_user = JSON.parse(JSON.stringify(this.user));
		},
		methods:{
			updateUser(){
				User.updateSelf(this.form_user)
				.then(() => {
					this.errors = [];
				})
				.catch(error => {
					if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
				});
			},
			updatePassword(){
				if(this.password1 != this.password2){
					Confirmation.swalErrorMessage('A jelszavak nem egyeznek!');
				}else {
					User.setPassword({password: this.password1})
					.then(() => {
						User.auth()
						.then(response => {
							this.$store.commit('updateUser',response.data);
							localStorage.setItem('user',JSON.stringify(response.data));
						});
						this.errors = [];
					})
					.catch(error => {
						if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
					});
				}
			},
			updatePin(){
				if(this.pin1 != this.pin2){
					Confirmation.swalErrorMessage('A pinkódok nem egyeznek!');
				}else {
					User.setPin({user_id: this.user.id, pin:this.pin1})
					.then(() => {
						this.errors = [];
					}).catch(error => {
						if(error.response.data.errors){
						this.errors = error.response.data.errors;
					}
					})
				}
			}
		}
	}
</script>